import MediaCenterPage from '@/pages/MediaCenterPage';

export default function MediaCenterPageAr() {
  return <MediaCenterPage lang="ar" />;
}
